module.exports = __webpack_public_path__ + "img/vjetrenjaca-4.99f1cf60.jpg";